import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

function SelectTenableReport(props) {
  const [options, setOptions] = useState([]);
  const { id, name, requiredAPI, selectnet, selectunit, local_net_name, local_unit_name, parentName, selectedReport, selecthost_ip, selectedDuration } = props;

  useEffect(() => {
    loadData();
  }, [selectnet, local_net_name, selectunit, local_unit_name, selecthost_ip, selectedDuration]);

  const loadData = () => {
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();

    switch (parentName) {
      case 'superS':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_id", selectunit);
        formData.append("local_unit_name", local_unit_name);
        formData.append("timelimit", selectedDuration);
        formData.append("host_ip", selecthost_ip);
        break;

      case 'superM':
        formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
        formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
        formData.append("local_unit_id", selectunit);
        formData.append("local_unit_name", local_unit_name);
        formData.append("timelimit", selectedDuration);
        formData.append("host_ip", selecthost_ip);
        break;

      case 'superN':
        formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
        formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
        formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
        formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'));
        formData.append("timelimit", selectedDuration);
        formData.append("host_ip", selecthost_ip);
        break;

      default:
        console.warn('Unknown parentName:', parentName);
        break;
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        const rows = Array.isArray(data.row) ? data.row : (data.row ? [data.row] : []);
        setOptions(rows);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedName = event.target.options[selectedIndex].text;
    props.selectReport({ name, value, selectedName });
  };

  return (
    <Input
      id={id}
      name={name}
      onChange={handleSelectChange}
      type='select'
      value={selectedReport}  // 使用 selectedReport 作為 value
    >
      <option key="0" value="">
        請選擇
      </option>
      {options.map(option => {
        // 格式化日期
        const originalFormat = option.build_date;
        const newFormat = originalFormat
          .replace(/\//g, "")
          .replace(/:/g, "")
          .replace(/ /g, "");

        // 組合最終顯示的字符串
        const displayText = `${newFormat}-${option.local_net_id}-${option.local_unit_id}-${option.serial_no}`;

        return (
          <option key={option.scan_id} value={option.scan_id}>
            {displayText}
          </option>
        );
      })}
    </Input>
  );
}

export default SelectTenableReport;
